import React, { useCallback, useMemo, useRef, useEffect, useState } from 'react';
import { createReactEditorJS } from 'react-editor-js';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import ImageTool from '@editorjs/image';
import LinkTool from '@editorjs/link';
import Button from '@mui/material/Button';
import {Divider} from "antd";
import { UPLOAD_URL, FETCH_RESOURCE_URL } from "../../Configs/Domain";
import { getAuthHeader } from "../../Store/utils";
import {WarningSharp} from "@mui/icons-material";

const ReactEditorJS = createReactEditorJS(); // This creates the React component

const ContentEditor = ({ initialData, onContentChange }) => {
  const editorCore = useRef(null);  // useRef to hold the editor instance
  const [hasChanges, setHasChanges] = useState(false);

  console.log("INITIAL DATA", initialData)
  const EDITOR_JS_TOOLS = useMemo(() => ({
    header: {
      class: Header,
      config: {
        placeholder: 'Enter a header', // Add a placeholder for the header
        levels: [1, 2, 3], // Specify the header levels you want to support
      },
    },
    list: List,
    image: {
      class: ImageTool,
      config: {
        endpoints: {
          byFile: UPLOAD_URL,
          byUrl: FETCH_RESOURCE_URL,
        },
        resizeHandles: true, // Show resize handles
        resizeMinWidth: 100, // Minimum width (optional)
        resizeMinHeight: 100, // Minimum height (optional)
        additionalRequestHeaders: getAuthHeader(),
      }
    },
    linkTool: {
      class: LinkTool,
      config:{
        endpoint: FETCH_RESOURCE_URL, // Your backend endpoint for url data fetching,

      }

    }
  }), []);

  const handleInitialize = useCallback((instance) => {
    editorCore.current = instance; // Stores the instance in the ref for later access
  }, []);

  const handleSave = useCallback(async () => {
    if (editorCore.current) {
      try {
        const savedData = await editorCore.current.save();
        onContentChange(savedData);  // Handle the saved data, e.g., update the state or send to the backend
        setHasChanges(false);  // Reset the state flag after
      } catch (error) {
      }
    }
  }, [onContentChange]);  // Depend on the onContentChange to ensure it's captured in the closure if it updates

    const handleChange = useCallback(() => {
      setHasChanges(true);  // Set the state flag to true on change
  }, []);

  return (
    <div style={{width: '100%'}}>
      {hasChanges && (
          <>
            <Button startIcon={<WarningSharp/>} endIcon={<WarningSharp/>} sx={{width: '100%'}} onClick={handleSave} variant="contained" color="error">
              CONFIRM These Changes BEFORE SAVING
            </Button>
            <Divider/>
          </>
      )}
      <ReactEditorJS
        onInitialize={handleInitialize}
        tools={EDITOR_JS_TOOLS}
        defaultValue={initialData}
        onChange={handleChange}  // Set hasChanges to true on change
        // onChange={handleSave}  // Remove onChange if saving is handled by button to avoid performance issues
      />
    </div>
  );
};

export default ContentEditor;
